import { render, staticRenderFns } from "./finance_config.vue?vue&type=template&id=715dff69&scoped=true"
import script from "./finance_config.vue?vue&type=script&lang=js"
export * from "./finance_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715dff69",
  null
  
)

export default component.exports